import { ApiProperty } from "@nestjs/swagger";

export class EmployeeTeamDto{

    @ApiProperty()
    id:number;

    @ApiProperty()
    employeeCode:string;

    @ApiProperty()
    employeeName:string;

    @ApiProperty()
    shiftCode:string;

    @ApiProperty()
    workStationTeam:string;
    
    
    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;
}